'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DISCOUNT, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeApplied() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_APPLIED + ' event');
    // TODO
    // import track helper
    // throw an error or track `eventName ERROR`
    // analytics.onload -> logging
    return (0, _track2.default)(_events.EVENT_COUPON_APPLIED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeApplied;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackVoucherCodeApplied.js
// module id = 1682
// module chunks = 0